import {createDailyLog$, deleteDailyLog$, getDailyLogs$, updateDailyLog$} from "../services/projects";
import {networkError} from "./ui";
import {extractSubview} from "./view";

export const ADD_DAILY_LOGS = 'ADD_DAILY_LOGS';
export const addDailyLogs = (list) => ({type: ADD_DAILY_LOGS, payload: list});
export const API_GET_DAILY_LOGS = 'API_GET_DAILY_LOGS';
export const getDailyLogs = (projectId, offset) => ({type: API_GET_DAILY_LOGS, payload: {projectId, offset}});
export const API_GET_DAILY_LOGS_DONE = 'API_GET_DAILY_LOGS_DONE';
export const getDailyLogsDone = (response) => ({type: API_GET_DAILY_LOGS_DONE, payload: response});
export const API_GET_DAILY_LOG = 'API_GET_DAILY_LOG';
export const getDailyLog = (projectId, id) => ({type: API_GET_DAILY_LOG, payload: {projectId, id}});
export const API_GET_DAILY_LOG_DONE = 'API_GET_DAILY_LOG_DONE';
export const getDailyLogDone = (response, callback) => ({ type: API_GET_DAILY_LOG_DONE, payload: { response, callback } });

export const createDailyLog = (projectId, dailyLog, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await createDailyLog$({ projectId, document: dailyLog }).toPromise();
    ({ response, status } = await getDailyLogs$({ id: response, projectId }).toPromise());
    dispatch(getDailyLogDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10134-'+error.status}));
  }
};

export const deleteDailyLog = (projectId, dailyLogId) => async (dispatch, getState) => {
  try {
    let { response, status } = await deleteDailyLog$({ projectId, subId: dailyLogId }).toPromise();
    dispatch(extractSubview([dailyLogId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10135-'+error.status}));
  }
};

export const updateDailyLog = (projectId, dailyLog) => async (dispatch, getState) => {
  try {
    let dailyLogId = dailyLog.id;
    let { response, status } = await updateDailyLog$({ projectId, subId: dailyLogId, document: dailyLog }).toPromise();
    let { response: response2, status: status2 } = await getDailyLogs$({ projectId, id: dailyLogId }).toPromise();
    dispatch(getDailyLogDone(response2));
  } catch (error) {
    dispatch(networkError({...error, number: '10136-'+error.status}));
  }
};




// WEBPACK FOOTER //
// ./src/actions/dailyLog.js